module.exports = __webpack_public_path__ + "static/media/databasesIcon.654c644f.svg";